/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useEffect, useState} from "react";
import {Button, Checkbox, Input, Popover} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown} from "@fortawesome/free-solid-svg-icons";


WidgetSelect.defaultProps = {
  disabled: false,
};


function WidgetSelect({ title, data, value, placeholder, inputStyle,
                        onChangeValues,
                        disabled }) {

  const [isInit, setIsInit] = useState(true);
  const [visiblePopover, setVisiblePopover] = useState(false);

  const [checkedList, setCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    if ( isInit ) {
      setIsInit(false);
    }
    else if (onChangeValues) {
      onChangeValues(checkedList);
    }

    setIndeterminate(checkedList.length > 0 && (checkedList.length < data.length));
    setCheckAll(checkedList.length > 0 && (checkedList.length === data.length));
  }, [checkedList]);

  const onCheckAllChange = useCallback(({ target: { checked } }) => {
    setCheckedList(checked ? data.map(({ value }) => value).slice(0) : []);
  }, [data]);

  useEffect(() => {
    setCheckedList(prev => {
      if ( JSON.stringify(prev) === JSON.stringify(value) )
        return prev;
      return value;
    })
  }, [value]);

  useEffect(() => {
    if ( checkedList.length < data.length ) {
      setText(`선택 ${checkedList.length}개`);
    }
    else {
      setText(`전체 선택 ${checkedList.length}개`);
    }
  }, [checkedList]);

  const { width=200 } = inputStyle;

  return (
    <div style={{ display: "inline-block" }}>
      <Popover
        placement={"bottom"}
        title={title}
        visible={visiblePopover}
        onVisibleChange={visible => setVisiblePopover(visible)}
        content={
          <>
            { disabled &&
              "EMPTY"
            }
            { !disabled &&
              <div style={{ width: (width-30), maxHeight: 400, overflowY: 'scroll' }}>
                <div style={{ paddingBottom: 10, borderBottom: '1px solid #E9E9E9', marginBottom: 10,
                              height: '32px', lineHeight: '32px',
                              display: 'flex', justifyContent: "space-between" }}>
                  <Checkbox indeterminate={indeterminate}
                            checked={checkAll}
                            onChange={onCheckAllChange}>
                    전체
                  </Checkbox>
                  <Button size={"small"} onClick={() => setVisiblePopover(false)}>선택완료</Button>
                </div>

                <Checkbox.Group value={checkedList}
                                onChange={value => setCheckedList(value)}>
                  {data.map(({ value, label }, index) =>
                    <div key={index}>
                      <Checkbox value={value}>
                        {label}
                      </Checkbox>
                    </div>
                  )}
                </Checkbox.Group>
              </div>
            }
          </>
      }>
        <Input style={inputStyle}
               value={text}
               disabled={disabled}
               contentEditable={false}
               placeholder={placeholder}
               suffix={<FontAwesomeIcon icon={faAngleDown} />} />
      </Popover>
    </div>
  );
};


export default WidgetSelect;
